import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import Badge from '../../node_modules/reactstrap/esm/Badge.js';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var BadgeItem = function BadgeItem(_ref) {
  var action = _ref.action,
    label = _ref.label;
  return /*#__PURE__*/React__default.createElement(Badge, {
    color: "primary",
    pill: true,
    onClick: action
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null), label);
};
var BadgeGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  border-top: 2px solid ", ";\n  border-bottom: 1px solid grey;\n  padding: 10px 15px;\n\n  span {\n    padding: 10px;\n    cursor: pointer;\n    margin: 5px;\n  }\n"])), Theme.colors.lightBlue);
var CloseIcon = styled.i.attrs(function (_props) {
  return {
    className: "fa fa-close"
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n"])));
var AddIcon = styled.i.attrs(function (_props) {
  return {
    className: "fa fa-plus"
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n"])));
var OptionBox = styled.li(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 5px;\n"])));
var Select = styled.ul(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: ", ";\n  top: 35px;\n  list-style: none;\n  background-color: white;\n  border: 1px solid ", ";\n  padding-inline-start: 0;\n"])), function (_ref2) {
  var visible = _ref2.visible;
  return visible ? "block" : "none";
}, Theme.colors.blueGrey);
var Option = function Option(_ref3) {
  var action = _ref3.action,
    label = _ref3.label,
    key = _ref3.key;
  return /*#__PURE__*/React__default.createElement(OptionBox, {
    onClick: function onClick() {
      return action(key);
    }
  }, label);
};
var BadgeSelectBox = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])));
var BadgeSelect = function BadgeSelect(_ref4) {
  var onSelect = _ref4.onSelect,
    options = _ref4.options,
    title = _ref4.title;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisibility = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    text = _useState4[0],
    setText = _useState4[1];
  var actionHandler = function actionHandler(key) {
    onSelect(key);
    setText("");
    setVisibility(false);
  };
  return /*#__PURE__*/React__default.createElement(BadgeSelectBox, null, /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return setVisibility(true);
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon, null), /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    placeholder: "Add ".concat(title),
    value: text,
    onChange: function onChange(e) {
      return setText(e.target.value);
    }
  })), /*#__PURE__*/React__default.createElement(Select, {
    visible: visible && text
  }, options.filter(function (_ref5) {
    var key = _ref5.key;
    return key.toLowerCase().includes(text.toLowerCase());
  }).map(function (_ref6) {
    var key = _ref6.key,
      label = _ref6.label;
    return /*#__PURE__*/React__default.createElement(Option, {
      action: function action() {
        return actionHandler(key);
      },
      label: label,
      key: key
    });
  })));
};
var reducer = function reducer(_ref7, _ref8) {
  var selected = _ref7.selected;
  var type = _ref8.type,
    data = _ref8.data;
  switch (type) {
    case "remove":
      {
        var idx = selected.findIndex(function (key) {
          return key === data;
        });
        return {
          selected: [].concat(_toConsumableArray(selected.slice(0, idx)), _toConsumableArray(selected.slice(idx + 1, selected.length)))
        };
      }
    case "add":
      return {
        selected: [].concat(_toConsumableArray(selected), [data])
      };
  }
};
var BadgeGroupDef = function BadgeGroupDef(_ref9) {
  var options = _ref9.options,
    _ref9$selecteds = _ref9.selecteds,
    selecteds = _ref9$selecteds === void 0 ? [] : _ref9$selecteds,
    title = _ref9.title;
  var _useReducer = useReducer(reducer, {
      selected: selecteds
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  return /*#__PURE__*/React__default.createElement(BadgeGroup, null, state.selected.map(function (key) {
    return /*#__PURE__*/React__default.createElement(BadgeItem, {
      key: key,
      color: "primary",
      action: function action() {
        return dispatch({
          type: "remove",
          data: key
        });
      },
      label: options.find(function (item) {
        return item.key === key;
      }).label
    });
  }), /*#__PURE__*/React__default.createElement(BadgeSelect, {
    title: title,
    options: options,
    onSelect: function onSelect(data) {
      return dispatch({
        type: "add",
        data: data
      });
    }
  }));
};
BadgeGroupDef.displayName = "BadgeGroup";
BadgeGroupDef.propTypes = {
  options: PropTypes.arrayOf(PropTypes.objectOf({
    key: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  selecteds: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired
};

export { BadgeGroupDef as default };
